var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shop_svg__Ebene_1",
    x: 0,
    y: 0,
    color: "#fff",
    viewBox: "0 0 24 29"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shop_svg__st0{fill:none;stroke:currentColor;stroke-width:3;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop_svg__Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop_svg__Medium-Copy-8",
    transform: "translate(-637 -6715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop_svg__Group-23",
    transform: "translate(639 6717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shop_svg__Path",
    d: "M20 25H0L.8 6.7h18.4z",
    className: "shop_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shop_svg__Path_00000178899912104624518120000003101158286390439076_",
    d: "M5.8 10V4.2C5.8 1.9 7.7 0 10 0c1.1 0 2.2.4 2.9 1.2s1.2 1.8 1.2 2.9V10",
    className: "shop_svg__st0"
  }))))));
};
export default SvgShop;